/* eslint-disable */

import { Checkbox, Col, Form, Image, Input, Row, Upload, message } from "antd";
import React, { useState } from "react";

import permissions from "../../../configs/permission";
import { usePermission } from "../../hooks/usePermission";
import { createHandleUpload, createHandlePreview, UploadButton, ImagePreview } from "../../utils/uploadUtils.jsx";

const { TextArea } = Input;

export const CreateCustomerDetail = ({ t, formCustomer, fileList, setFileList, type }) => {
  const { hasPermission, isSuperuser, hasGroup } = usePermission();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const handleUpload = createHandleUpload(messageApi);
  const handlePreview = createHandlePreview(setPreviewImage, setPreviewOpen);

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadButton = <UploadButton />;

  return (
    <>
      {contextHolder}
      <Row align="middle" justify="center">
        <Col span={24}>
          <Row gutter={10}>
            <Col flex={3}>
              <Form
                form={formCustomer}
                labelAlign="left"
                labelCol={{
                  flex: "140px",
                }}
              >
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Table.Is_Credit") + ":"}
                    name="customer_is_credit"
                    valuePropName="checked"
                  >
                    <Checkbox>{t("Customer_Create.Create_Detail.Check_Credit")}</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Line_Id") + ":"}
                    name="customer_line_id"
                    key="customer_line_id"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                  >
                    <Input allowClear={true} size="default" placeholder={"line id"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Tax_Id") + ":"}
                    name="customer_tax_id"
                    key="customer_tax_id"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input allowClear={true} size="default" placeholder={"tax id"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Email") + ":"}
                    name="customer_email"
                    key="customer_email"
                    style={{ marginBottom: "1rem" }}
                    rules={[
                      {
                        type: "email",
                      },
                    ]}
                  >
                    <Input allowClear={true} size="default" placeholder={"email"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Telephone") + ":"}
                    name="customer_telephone"
                    key="customer_telephone"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input allowClear={true} size="default" placeholder={"tel"} maxLength={10} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Address") + ":"}
                    name="customer_address"
                    key="customer_address"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input allowClear={true} size="default" placeholder={"address"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Delivery_Address") + ":"}
                    name="delivery_address"
                    key="delivery_address"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input allowClear={true} size="default" placeholder={"delivery_address"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Customer_Create.Create_Detail.Note") + ":"}
                    name="customer_note"
                    key="customer_note"
                    style={{ marginBottom: "1rem" }}
                  >
                    <TextArea allowClear={true} rows={4} />
                  </Form.Item>
                </Col>
              </Form>
            </Col>
            <Col span={12}>
              <Form form={formCustomer} labelCol={{ flex: "130px" }}>
                <Row gutter={10} style={{ justifyContent: "left", alignSelf: "baseline" }}>
                  {hasPermission(permissions.CustomerImage?.VIEW) && (
                    <Col span={24}>
                      {t("Customer_Create.Create_Detail.Max_Upload_Pic")}
                      <Upload
                        customRequest={handleUpload}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        maxCount={8}
                        disabled={
                          (type === "CREATE" && !hasPermission(permissions.CustomerImage.ADD)) ||
                          (type === "EDIT" && !hasPermission(permissions.CustomerImage.CHANGE))
                        }
                        onRemove={() => {
                          if (!hasPermission(permissions.CustomerImage?.DELETE)) {
                            message.warning("You are not allowed to remove this file.");
                            return false;
                          }
                        }}
                      >
                        {fileList.length >= 8 ? null : uploadButton}
                      </Upload>
                      <ImagePreview
                        previewImage={previewImage}
                        previewOpen={previewOpen}
                        setPreviewOpen={setPreviewOpen}
                        setPreviewImage={setPreviewImage}
                        Image={Image}
                      />
                    </Col>
                  )}
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
